import * as React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import {
  StyledContainer,
  StyledAttachmentPanel,
  StyledCloseButton,
} from './StyledComponents';
import Modal from '../Modal';
import Button from '../Button';
import FileViewer from '../FileViewer';
import FileProgress from './FileProgress';
import { FileType } from './types';
import FileItem from './FileItem';

export type FileListProps = {
  files?: FileType[];
  onRemoveFile: (file: FileType, i: number) => void;
  showPreview?: boolean;
  className?: string;
  singleColumn?: boolean;
  extra?: (file: FileType) => React.ReactNode;
  onClick?: (file: FileType) => void;
};

export { FileType };

export const FileList: React.FC<FileListProps> = ({
  files,
  className = '',
  onRemoveFile,
  showPreview,
  singleColumn,
  extra,
  onClick,
}) => {
  if (!files) return null;
  return (
    <StyledContainer
      onClick={e => e.stopPropagation()}
      className={className}
      $singleColumn={singleColumn}
    >
      {files.map((file, i) => (
        <StyledAttachmentPanel
          key={file.uid}
          $error={file.status === 'error'}
          href={showPreview && file.status === 'done' ? file.url : null}
          target="_blank"
          rel="noreferrer"
        >
          <FileItem displaySize file={file} extra={extra} onClick={onClick} />
          <StyledCloseButton onClick={() => onRemoveFile(file, i)}>
            <Icon type="antdCloseOutlined" width={14} height={14} />
          </StyledCloseButton>
          <FileProgress percent={file.percent} />
        </StyledAttachmentPanel>
      ))}
    </StyledContainer>
  );
};

export default styled(FileList)``;

export { FileItem };
